import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import OrderSummaryDetails from './orderSummaryDetails/OrderSummaryDetails';
import SurgeryDetails from './surgeryDetails/SurgeryDetails';
import SurgeryDetail from '../../../../consignmentAdd/components/submit/SurgeryDetails';
import ProcedureDetails from './procedureDetails/ProcedureDetails';
import ShippingDetails from './shippingDetails/ShippingDetails';
import SurgeryNotes from './surgeryNotes/SurgeryNotes';
import AccountDetails from './accountDetails/AccountDetails';
import { getDisplayDate, getTimeZoneName } from 'src/utils/dateUtils';
import { convertTime24To12 } from 'src/utils/util';
import { InvoiceCreatedDetail } from './orderSummaryDetails/OrderSummaryDetails.styled';
import { OrderDetailTitle } from 'src/pages/orders/components/orderDetails/OrderDetails.styled';
import { useTranslation } from 'react-i18next';
import { WrapperContainer } from './orderSummaryDetails/OrderSummaryDetailsCard.styled';
import { OrderDetailFooterContainer } from './OrderSummary.styled';
import ConsignmentTermData from './consignmentTerm/ConsignmentTerm';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const OrderSummary = () => {
    const { t } = useTranslation();

    const [modifyDate, setModifyDate] = useState('');
    const [modifyTime, setModifyTime] = useState('');
    // const [accountDetails, setAccDetails] = useState([]);
    const [orderType, setOrderType] = useState();
    const [notes, setNotes] = useState([]);
    //  const [shipDetails, setShipDetails]=useState();

    const { orderBasicDetails } = useSelector(
        (state) => state.orderSummaryReducer
    );
    const { isLongTermConsignment, isShortTermConsignment } = useSelector(
        (state) => state.orderSummaryReducer
    );

    const countryISOCode = useSelector(
        (state) => state.loginReducer.hybrisUserDetails.countryISOCode
    );
    const [expandedCard, setExpandedCard] = useState({
        isFullyInvoiced: true,
        isSurgeryDetails: true,
        isProcedureDetails: true,
        isShippingDetails: true,
        isSurgeryNotes: true,
        isAccountDetails: true,
    });

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    const {
        isFullyInvoiced,
        isSurgeryDetails,
        isProcedureDetails,
        isShippingDetails,
        isSurgeryNotes,
        isAccountDetails,
    } = expandedCard;

    const {
        orderDescription,
        orderSummaryDetail,
        procedureDetail,
        shippingDetails,
        surgeryNotes,
        currentOrderType,
        isFromOrderHistory,
        customerSurgeryNotes,
        equitycustomerNotes,
        consignmentBillingCustomerNotes,
        consignmentReplenishmentNotes,
        consignmentcustomerNotes,
        usageReplenishmentcustomerNotes,
        usagecustomerNotes,
        // accountDetails, //change when Account details come from API
    } = orderBasicDetails || {};
    const { isLanguageChanged } = useSelector((state) => ({
        isLanguageChanged: state.loginReducer.isLanguageChanged,
    }));
    const { lastModifiedDate, lastModifiedBy } = orderSummaryDetail || {};

    useEffectWithErrorLogging(() => {
        if (lastModifiedDate && lastModifiedDate !== '') {
            setModifyDate(getDisplayDate(new Date(lastModifiedDate)));
            setModifyTime(convertTime24To12(new Date(lastModifiedDate)));
        }
    }, [lastModifiedDate]);

    useEffectWithErrorLogging(() => {
        setOrderType(currentOrderType);
    }, []);

    useEffectWithErrorLogging(() => {
        customerSurgeryNotes?.length > 0 &&
            customerSurgeryNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        surgeryNotes?.length > 0 &&
            surgeryNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        usageReplenishmentcustomerNotes?.length > 0 &&
            usageReplenishmentcustomerNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        usagecustomerNotes?.length > 0 &&
            usagecustomerNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        consignmentcustomerNotes?.length > 0 &&
            consignmentcustomerNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        consignmentBillingCustomerNotes?.length > 0 &&
            consignmentBillingCustomerNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        consignmentReplenishmentNotes?.length > 0 &&
            consignmentReplenishmentNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        equitycustomerNotes?.length > 0 &&
            equitycustomerNotes.sort((a, b) => {
                return new Date(b.creationDate) - new Date(a.creationDate);
            });
        let consAddNotes =
            consignmentcustomerNotes?.length > 0
                ? [{ notesAr: [...consignmentcustomerNotes] }]
                : [];
        let cusConBilNotes =
            consignmentBillingCustomerNotes?.length > 0
                ? [
                      {
                          notesAr: [...consignmentBillingCustomerNotes],
                          header: t('reportUsage.consignmentBillingNotes'),
                      },
                  ]
                : [];
        let conBilRepNotes =
            consignmentReplenishmentNotes?.length > 0
                ? [
                      {
                          notesAr: [...consignmentReplenishmentNotes],
                          header: t(
                              'reportUsage.consignmentReplenishmentNotes'
                          ),
                      },
                  ]
                : [];
        let equityNotes =
            equitycustomerNotes?.length > 0
                ? [{ notesAr: [...equitycustomerNotes] }]
                : [];
        let cusSurNotes =
            customerSurgeryNotes?.length > 0
                ? [
                      {
                          notesAr: [...customerSurgeryNotes],
                          header: t(
                              'scheduleSurgery.surgery.SurgeryReviewAndSuccess.customerCareSuregeryNotes'
                          ),
                      },
                  ]
                : [];
        let surNotes =
            surgeryNotes?.length > 0
                ? [
                      {
                          notesAr: [...surgeryNotes],
                          header: t(
                              'scheduleSurgery.surgery.SurgeryNotes.surgeryNotes'
                          ),
                      },
                  ]
                : [];
        let UsageRepNotes =
            usagecustomerNotes?.length > 0
                ? [
                      {
                          notesAr: [...usagecustomerNotes],
                          header: t('common.summaryUsageCustomerCareNote'),
                      },
                  ]
                : [];
        let cusUsageNotes =
            usageReplenishmentcustomerNotes?.length > 0
                ? [
                      {
                          notesAr: [...usageReplenishmentcustomerNotes],
                          header: t('common.summaryUsageReplenishNote'),
                      },
                  ]
                : [];

        setNotes([
            ...cusSurNotes,
            ...surNotes,
            ...equityNotes,
            ...cusConBilNotes,
            ...conBilRepNotes,
            ...consAddNotes,
            ...UsageRepNotes,
            ...cusUsageNotes,
        ]);
    }, [
        customerSurgeryNotes,
        surgeryNotes,
        equitycustomerNotes,
        consignmentBillingCustomerNotes,
        consignmentReplenishmentNotes,
        consignmentcustomerNotes,
    ]);

    return (
        <>
            {/* {orderType==='ZLB'?  */}
            <OrderDetailFooterContainer>
                {lastModifiedBy || modifyDate || modifyTime ? (
                    <>
                        <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                            {isLanguageChanged && lastModifiedBy
                                ? ''
                                : t('orders.orderSummaryTabs.lastmodify')}
                        </InvoiceCreatedDetail>
                        {lastModifiedBy ? (
                            <>
                                <InvoiceCreatedDetail margin={'0 3px 0 0'}>
                                    {isLanguageChanged
                                        ? t(
                                              'orders.orderSummaryTabs.lastmodify'
                                          )
                                        : t(
                                              'orders.orderDetails.billingSummary.by'
                                          )}
                                </InvoiceCreatedDetail>
                                <InvoiceCreatedDetail
                                    margin={'0 2px 0 0'}
                                    isCreatedDateBy
                                >
                                    {lastModifiedBy}
                                </InvoiceCreatedDetail>
                            </>
                        ) : null}
                        <WrapperContainer>
                            {modifyDate ? (
                                <InvoiceCreatedDetail margin={'0 2px 0 -1px'}>
                                    {modifyDate}
                                </InvoiceCreatedDetail>
                            ) : null}
                            {modifyTime ? (
                                <InvoiceCreatedDetail>
                                    {modifyTime} {getTimeZoneName()}
                                </InvoiceCreatedDetail>
                            ) : null}
                        </WrapperContainer>
                    </>
                ) : null}
            </OrderDetailFooterContainer>
            {/* :null} */}
            <OrderDetailTitle>
                <div style={{ marginLeft: '15px' }}>
                    {t('orders.orderSummaryTabs.orderSummary')}
                </div>
            </OrderDetailTitle>
            {orderDescription?.length > 0 ? (
                <OrderSummaryDetails
                    toggleCard={toggleCard}
                    isFullyInvoiced={isFullyInvoiced}
                />
            ) : null}
            {orderType === 'ZOR' ? (
                <AccountDetails
                    // accountDetails={accountDetails}
                    toggleCard={toggleCard}
                    isAccountDetails={isAccountDetails}
                />
            ) : null}
            {orderSummaryDetail && orderType !== 'ZOR' ? (
                <SurgeryDetails
                    toggleCard={toggleCard}
                    isSurgeryDetails={isSurgeryDetails}
                />
            ) : null}
            {orderType === 'KB' &&
            (isLongTermConsignment || isShortTermConsignment) ? (
                <ConsignmentTermData
                    term={
                        isLongTermConsignment
                            ? t('reportUsage.longTerm')
                            : isShortTermConsignment
                            ? t('reportUsage.shortTerm')
                            : ''
                    }
                />
            ) : null}
            {orderType === 'KB' && orderSummaryDetail?.implantDate ? (
                <SurgeryDetail
                    isSubmitClicked={true}
                    procedures={orderSummaryDetail?.procedure}
                    implantDate={orderSummaryDetail?.implantDate}
                    countryCode={countryISOCode}
                    isOrderDetailsPage={true}
                />
            ) : null}
            {procedureDetail ? (
                <ProcedureDetails
                    toggleCard={toggleCard}
                    isProcedureDetails={isProcedureDetails}
                />
            ) : null}
            {shippingDetails && orderType === 'ZOR' && !isFromOrderHistory ? (
                <ShippingDetails
                    toggleCard={toggleCard}
                    shipDetails={shippingDetails}
                    isEquity={true}
                    isShippingDetails={isShippingDetails}
                />
            ) : null}
            {shippingDetails && orderType !== 'ZOR' && !isFromOrderHistory ? (
                <ShippingDetails
                    toggleCard={toggleCard}
                    isShippingDetails={isShippingDetails}
                />
            ) : null}

            {notes && notes?.length > 0 ? (
                <SurgeryNotes
                    toggleCard={toggleCard}
                    isSurgeryNotes={isSurgeryNotes}
                    notes={notes}
                    currentOrderType={currentOrderType}
                />
            ) : null}
            {/* {orderType!=='ZLB' ? 
            <OrderDetailFooterContainer>
                {lastModifiedBy || modifyDate || modifyTime ? (
                    <>
                        <InvoiceCreatedDetail
                            margin={'0 3px 0 0'}
                        >{'Last Modified'}</InvoiceCreatedDetail>
                        {lastModifiedBy ? (
                            <>
                                <InvoiceCreatedDetail
                                    margin={'0 3px 0 0'}
                                >{'by'}</InvoiceCreatedDetail>
                                <InvoiceCreatedDetail
                                    margin={'0 2px 0 0'}
                                    isCreatedDateBy
                                >
                                    {lastModifiedBy}
                                </InvoiceCreatedDetail>
                            </>
                        ) : null}
                        <WrapperContainer>
                            {modifyDate ? (
                                <InvoiceCreatedDetail margin={'0 2px 0 -1px'}>
                                    {modifyDate}
                                </InvoiceCreatedDetail>
                            ) : null}
                            {modifyTime ? (
                                <InvoiceCreatedDetail>
                                    {modifyTime} {' '} {getTimeZoneName()}
                                </InvoiceCreatedDetail>
                            ) : null}
                        </WrapperContainer>
                    </>
                ) : null}
            </OrderDetailFooterContainer>:null} */}
        </>
    );
};

export default OrderSummary;
